var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3966 0C26.6744 0 34.2067 7.53237 34.2067 16.8101C34.2067 26.0878 26.6744 33.6202 17.3966 33.6202C8.11892 33.6202 0.586548 26.0878 0.586548 16.8101C0.586548 7.53237 8.11892 0 17.3966 0ZM14.4358 25.7508C21.8744 25.7508 25.9418 19.5869 25.9418 14.2449C25.9418 14.0688 25.9418 13.8927 25.9333 13.7249C26.7216 13.1547 27.4094 12.4418 27.9544 11.6284C27.2332 11.9471 26.4533 12.1651 25.6314 12.2657C26.4701 11.7625 27.1074 10.9742 27.4094 10.0266C26.6294 10.4879 25.7656 10.8233 24.8431 11.0078C24.1051 10.2195 23.0569 9.73311 21.8912 9.73311C19.6604 9.73311 17.849 11.5445 17.849 13.7753C17.849 14.094 17.8826 14.4042 17.958 14.6977C14.5951 14.53 11.618 12.9199 9.62211 10.471C9.27822 11.0665 9.07696 11.7625 9.07696 12.5005C9.07696 13.901 9.78981 15.1422 10.88 15.8634C10.2175 15.8467 9.59689 15.6621 9.05181 15.3603V15.4106C9.05181 17.373 10.4439 18.9999 12.2973 19.3773C11.9619 19.4695 11.6012 19.5199 11.2323 19.5199C10.9722 19.5199 10.7207 19.4947 10.4691 19.4444C10.9806 21.0545 12.4734 22.2203 14.2429 22.2537C12.8592 23.3356 11.1149 23.9814 9.21952 23.9814C8.89244 23.9814 8.57377 23.9646 8.2551 23.9227C10.0246 25.0799 12.1547 25.7508 14.4358 25.7508Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default "/Frontend/static/media/twitter.b4976e38d7e9e3eea187ec16849049cf.svg";
export { ForwardRef as ReactComponent };